// libs
import React, { useState, useRef, useEffect } from 'react';

//styles
import { PopUpContainer, Separator, TopContainer, Wrapper } from './styles';

//components
import SearchBar from 'shared/components/Filter/components/SearchBar';
import AlphabetStrip from 'shared/components/Filter/components/AlphabetStrip';
import FiltersList from 'shared/components/Filter/components/FiltersList';
import ButtonsContainer from 'shared/components/Filter/components/ButtonsContainer';
import CollapsedFilter from 'shared/components/Filter/components/CollapsedFilter';

//helpers
import { isSameArray, getUpdatedFilters } from 'shared/components/Filter/helpers';
import { getFilteredValuesAndAlphabets } from './helpers';

//constants
import { FILTER_UI_TYPES } from 'shared/layouts/Listing/constants';

interface IPopUpView {
  filter: Listing.IFilter;
  onApplyClick: (value: string) => VoidFunction;
  checkedFilters: string[];
  showAlphabetHeading: boolean;
  isCollapsedView: boolean;
  onClick: () => VoidFunction;
}

function PopUpView({
  filter,
  onApplyClick,
  checkedFilters,
  showAlphabetHeading = false,
  isCollapsedView,
  onClick,
}: IPopUpView) {
  const { title, values, type, show_search_box } = filter;
  const [searchText, setSearchText] = useState('');
  const [selectedAlphabet, setSelectedAlphabet] = useState('');
  const [selectedOptions, setSelectedOptions] = useState(checkedFilters);

  const popupRef = useRef<HTMLDivElement>(null);

  const { filterValues, availableAlphabets } = getFilteredValuesAndAlphabets(
    showAlphabetHeading,
    values,
    searchText
  );

  const onValueSelect = (item: string) => {
    setSelectedOptions(
      getUpdatedFilters(selectedOptions, type === FILTER_UI_TYPES.MULT_SLECT, item)
    );
  };

  useEffect(() => {
    if (!isCollapsedView) popupRef?.current?.scrollIntoView({ behavior: 'smooth', block: 'end' });
    if (isCollapsedView) {
      if (!isSameArray(selectedOptions, checkedFilters)) setSelectedOptions(checkedFilters);
      setSearchText('');
    }
  }, [checkedFilters, isCollapsedView, selectedOptions]);

  return (
    <Wrapper>
      <CollapsedFilter
        title={title}
        isCollapsedView={isCollapsedView}
        onArrowClick={onClick}
        selectedFiltersCount={checkedFilters.length}
        isOverlayFilter
      />
      {!isCollapsedView && (
        <PopUpContainer ref={popupRef}>
          {show_search_box && (
            <>
              <TopContainer>
                <SearchBar searchText={searchText} setSearchText={setSearchText} title={title} />

                {showAlphabetHeading && (
                  <AlphabetStrip
                    setSelectedAlphabet={setSelectedAlphabet}
                    availableAlphabets={availableAlphabets}
                  />
                )}
              </TopContainer>
              <Separator />
            </>
          )}

          <FiltersList
            selectedOptions={selectedOptions}
            onFilterSelection={onValueSelect}
            searchText={searchText}
            selectedAlphabet={selectedAlphabet}
            showAlphabetHeading={showAlphabetHeading}
            values={filterValues}
            type={type}
            isPopUp
          />

          <ButtonsContainer
            onApplyClick={onApplyClick}
            collapseFilter={onClick}
            selectedOptions={selectedOptions}
            setSelectedOptions={setSelectedOptions}
            isApplyButtonDisabled={isSameArray(selectedOptions, checkedFilters)}
          />
        </PopUpContainer>
      )}
    </Wrapper>
  );
}

export default PopUpView;
